function initSlider(elementId, fromElementId, toElementId, valueElementId, min, max, step, formatter, formatterArgument) {
	var element = document.getElementById(elementId);
	var fromElement = document.getElementById(fromElementId);
	var toElement = document.getElementById(toElementId);
	var valueElement = document.getElementById(valueElementId);

	var startFrom = fromElement.value ? parseInt(fromElement.value) : min;
	var startTo = toElement.value ? parseInt(toElement.value) : max;

	step = max > 1000000 ? 10000 : Math.floor(max / 100);
	var half = max > 1000000 ? 100000 : max * .1;

	noUiSlider.create(element, {
		start: [startFrom, startTo],
		connect: true,
		// step: step,
		// range: {
		// 	'min': min,
		// 	'max': max
		// }
		range: {
			'min': [min, step / 10],
			'59%': [half, step / 10],
			'76%': [half + (max * .1), step],
			'87%': [half + (max * .2), step],
			'94%': [half + (max * .3), step],
			'max': [max]
		}
	});

	element.noUiSlider.on('update', function (values, handle, unencoded) {
		valueElement.textContent = format(unencoded[0]) + ' – ' + format(unencoded[1]);
	});

	element.noUiSlider.on('change', function (values, handle, unencoded) {
		fromElement.value = Math.round(unencoded[0]);
		toElement.value = Math.round(unencoded[1]);
	});

	fromElement.addEventListener('keyup', function(e) {
		var newValue = fromElement.value.replace(/[^0-9.]+/g, '');
		element.noUiSlider.set([newValue, null]);
		// element.noUiSlider.updateOptions({
		// 	start: newValue,
		// });
	});
	toElement.addEventListener('keyup', function(e) {
		var newValue = toElement.value.replace(/[^0-9.]+/g, '');
		element.noUiSlider.set([null, newValue]);
	});

	function format(value) {
		return formatter ? formatter(value, formatterArgument) : value;
	}
}

function formatPrice(value, locale) {
	//console.log(locale.replace('_','-'));
	return value.toLocaleString(locale.replace('_','-'), {
		style: 'currency',
		currency: 'EUR',
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	});
}

function formatUnit(value, unit, locale, emptyLimit) {
	if(value === emptyLimit) {
		return '∞';
	}

	return value.toLocaleString(locale.replace('_','-'), {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	}) + ' ' + unit;
}